// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterBackImages_root__2wJei","title":"AfterBackImages_title__fUPpJ","images":"AfterBackImages_images__3dUAV"};